import CrudPage from "@/components/app/CrudPage";
import { formatTL, formatDate } from "@/lib/api";

export default function DriversPage() {
  return (
    <CrudPage
      title="Şoförler"
      subtitle="Şoför bilgileri, maaşları ve iletişim detayları."
      endpoint="/drivers"
      testidPrefix="drivers"
      fields={[
        { key: "name", label: "Ad Soyad", type: "text", required: true },
        { key: "phone", label: "Telefon", type: "text" },
        { key: "license_no", label: "Ehliyet No", type: "text" },
        { key: "monthly_salary", label: "Aylık Maaş (₺)", type: "number", defaultValue: 0 },
        { key: "hire_date", label: "İşe Başlama Tarihi", type: "date" },
        { key: "notes", label: "Notlar", type: "textarea" },
      ]}
      columns={[
        { key: "name", label: "Ad Soyad" },
        { key: "phone", label: "Telefon" },
        { key: "license_no", label: "Ehliyet" },
        { key: "monthly_salary", label: "Aylık Maaş", align: "right", render: (r) => formatTL(r.monthly_salary) },
        { key: "hire_date", label: "İşe Başlama", render: (r) => formatDate(r.hire_date) },
      ]}
    />
  );
}
